import { Col, Row } from 'react-bootstrap';

const CompanySnapshotRow = ({ label, value }) => (
  <Row className="border-bottom border-gray-400 border-gray-400">
    <Col lg={12}>
      <div className="px-16 py-24">
        <Row className="gy-8">
          <Col md={4}>
            <p className="mb-0 fw-800 text-muted">{label}</p>
          </Col>
          <Col md={8}>
            <p className="mb-0 fw-300" style={{ whiteSpace: 'pre-wrap' }}>{value}</p>
          </Col>
        </Row>
      </div>
    </Col>
  </Row>
);

export default CompanySnapshotRow;
